import './App.scss';
import 'bulma/css/bulma.css'
import { Route, Switch, useHistory, useLocation, useRouteMatch } from 'react-router-dom'
import Header from './commonComponents/Header'
import Home from "./AppComponents/Home"
import Game from "./AppComponents/Game"
import PrivacyPolicy from './commonComponents/PrivacyPolicy';
import FillOtp from './AppComponents/FillOtp';
import Subscription from './AppComponents/Subscription';
import TermsAndConditions from './commonComponents/TermsandCondition';
import Info from "./commonComponents/Info";
import Sorry from './commonComponents/Sorry';
import NotFound from "./AppComponents/NotFound"
import { useEffect, useState } from 'react';
import SideMenu from './AppComponents/SideMenu';
import ReactGA from 'react-ga';
import { useLanguage } from './Context/LangContext';
import { reactLocalStorage } from 'reactjs-localstorage';
import config from "./config"
import Category from './commonComponents/Category';
import Profile from "./AppComponents/Profile";
import Unsubscribe from './AppComponents/Unsubscribe';
import Language from './commonComponents/Language';
import ProtectedRoute from './ProtectedRoute';
import LoginPage from './AppComponents/LoginPage';
import Info2 from './commonComponents/Info2';
import { setCacheTimestamp, isCacheExpired } from './commonComponents/cacheManager';
import { injectScript, removeScript } from './scriptUtils';

function App() {
      const {language,setIP}=useLanguage();
      const [sideMenu, setSideMenu] = useState(false)
      const {pathname}=useLocation();
      const [showSideMenu, setshowSideMenu] = useState(true)
      const [loading , setLoading] = useState(true)
      const [banners,setBanners]=useState([])
      const [games,setGames]=useState([])
      const match1 = useRouteMatch('/game/:id')
      const [appConfigData, setappConfigData] = useState({})
      const history = useHistory();
      useEffect(() => {
            // ReactGA.initialize('G-6HPV1TM4W4');
            // ReactGA.pageview(window.location.href)
            getAppConfigData()
      }, [language]);
      useEffect(() => {
            const fetchIP = async () => {
              try {
                const response = await fetch('https://api.ipify.org?format=json');
                const data = await response.json();
                setIP(data.ip);
                localStorage.setItem("ipAddress",data.ip)
              } catch (error) {
                console.error('Error fetching the IP address:', error);
              }
            };
        
            fetchIP();
          }, []);
        
      const headerRoutes=["/subs","/otp","/info","/sorry","/privacy","/terms","/login","/info2","/promo"];
      const normalizedPathname = pathname.replace(/\/+$/, '');
      const showHeader = headerRoutes.some(route => normalizedPathname === route);
      // let showHeader=headerRoutes?.includes(pathname);
      useEffect(() => {
            console.log("Analytics initialize")
            const ga_tag = config.get("ga_tag");
            const ga_debug = config.get("ga_debug");
            console.log("GOOGLE ANALYTICS DEBUG :: ", ga_tag, " :: ", ga_debug);
            ReactGA.initialize(ga_tag, {
              debug: ga_debug,
              titleCase: false,
            });
            // to report page view
            history.listen((location) => {
              ReactGA.set({ page: location.pathname });
              ReactGA.pageview(location.pathname);
            });
          }, []);

      const getAppConfigData = () => {
            setLoading(true)
            const url = `${config.get('base')}${config.get('appConfig')}`;
            const headers={
                  ...config.get('headers'),
                  Language:language
            }
            fetch(url, {
                  method: 'POST',
                  body: JSON.stringify({ "mcc": "652", "mnc": "04" ,"uid" : reactLocalStorage.get("uid") ? reactLocalStorage.get("uid") : ""}),
                  headers:headers
            })
                  .then(res => {
                        if (!res.ok) { throw res }
                        return res.json()
                  })
                  .then((result) => {
                        console.log('result message appConfig ::', result)
                        const appConfigObj = {
                              menu: result.menu,
                              menu_color: result.menu_color,
                              home_logo: result.home_logo,
                              menu_logo: result.menu_logo,
                              view_all:result.view_all,
                              bg_color:result.bkg_color,
                              play_text:result.play_btn_txt,
                              flow:result.subRedirectFlow,
                              view_btn_txt:result.view_btn_txt,
                              sub_url:result.sub_url,
                              unsub_mode:result.unsubMode,
                              sidemenu:result.sidemenu,
                              unsub_msg_txt:result.unsubData,
                              portrait_txt:result.portrait_txt,
                              rotate_txt:result.rotate_txt,
                              landscape_txt:result.landscape_txt,
                              status_txt:result.status_txt,
                              similar_cat_txt:result.similar_cat_txt,
                              validity_text:result.validity_text,
                              plantype_text:result.plantype_text,
                        }
                        setappConfigData(appConfigObj)
                        setLoading(false)
                        setGames(result.games_list)
                        setBanners(result.banner)
                        reactLocalStorage.set("home_logo",result.home_logo)
                        reactLocalStorage.set("unsub_msg_txt",result.unsub_msg_txt)
                  }, 
                        (error) => {
                              console.log('error:::', error)
                        })
      }

      useEffect(() => {
            const currentPath = pathname;
            console.log("currentPath:::",currentPath)
            reactLocalStorage.set("injectScript",'true')
            const scriptId = 'gtag-script';
            const scriptSrc = 'https://www.googletagmanager.com/gtag/js?id=AW-16584996091';
            const inlineScript = `
                window.dataLayer = window.dataLayer || [];
                function gtag(){dataLayer.push(arguments);}
                gtag('js', new Date());
                gtag('config', 'AW-16584996091');
                gtag('event', 'conversion', {'send_to': 'AW-16584996091/x7sACOu53MgZEPvpq-Q9'});
            `;
            if (reactLocalStorage.get("injectScript")==="true" && (currentPath === '/home' || currentPath === '/info')) {
                injectScript(scriptSrc, scriptId, inlineScript);
            } else {
                removeScript(scriptId);
            }
    
            return () => {
                removeScript(scriptId);
            };
        }, [pathname]);
      
      const clearServiceWorkerCache = async () => {
            const cacheNames = await caches.keys();
            await Promise.all(
              cacheNames.map(cacheName => caches.delete(cacheName))
            );
          };
      
          const clearLocalStorage = () => {
            Object.keys(localStorage).forEach(key => {
              if (key !== 'cache-timestamp') {
                localStorage.removeItem(key);
              }
            });
          };
          
          // Function to clear both caches
          const clearCache = async () => {
            await clearServiceWorkerCache();
            clearLocalStorage();
            setCacheTimestamp();
            console.log('Cache cleared and timestamp updated.');
          };
          
          // Check if cache is expired and clear if necessary
          if (isCacheExpired()) {
            clearCache();
          } else {
            console.log('Cache is still valid.');
          }


      return (
            <section className={`hero is-fullheight bg ${showHeader?'subBg':null}`} style={{padding:"0px"}}>
                  {!(match1) && !showHeader &&  <Header loading={loading} menuBar = {appConfigData.menu} 
                  sub_url={appConfigData.sub_url}
                  sidemenu={appConfigData?.sidemenu}
                  menuLogo={appConfigData.menu_logo} homeLogo={appConfigData.home_logo} handleClick={() => setSideMenu(!sideMenu)} showSideMenu={showSideMenu} 
                  setshowSideMenu={()=>setshowSideMenu(!showSideMenu)}  />}
                  <SideMenu menuColor= {appConfigData.menu_color} menuLogo={appConfigData.menu_logo} sideMenu={sideMenu} handleClose={() => setSideMenu(!sideMenu)} />
                  <Switch>
                        <ProtectedRoute  path="/home"
                        component={(routeProps) => (
                              <Home
                                {...routeProps}
                                games={games}
                                banners={banners}
                                bgColor={appConfigData?.bg_color}
                                view_all={appConfigData?.view_all}
                                setLoading={setLoading}
                                flow={appConfigData?.flow}
                                loading={loading}
                                view_btn_txt={appConfigData?.view_btn_txt}
                              />
                            )}
                        />
                        <Route exact path="/">
                        <Home
                                games={games}
                                banners={banners}
                                bgColor={appConfigData?.bg_color}
                                view_all={appConfigData?.view_all}
                                setLoading={setLoading}
                                flow={appConfigData?.flow}
                                loading={loading}
                                view_btn_txt={appConfigData?.view_btn_txt}
                              />
                        </Route>
                        <Route path="/login">
                              <LoginPage homeLogo={appConfigData.home_logo} loading={loading}  setLoading={setLoading}/>
                        </Route>
                         <Route path="/subs">
                              <Subscription homeLogo={appConfigData.home_logo} banners={banners} loading={loading} setLoading={setLoading}/>
                        </Route>
                  
                        <Route path="/otp">
                              <FillOtp homeLogo={appConfigData.home_logo} banners={banners} loading={loading}  setLoading={setLoading}/>
                        </Route>
                        
                        <Route path="/info">
                              <Info homeLogo={appConfigData.home_logo} banners={banners} loading={loading} setLoading={setLoading}/>
                        </Route>
                        <Route path="/info2">
                              <Info2 homeLogo={appConfigData.home_logo} banners={banners} loading={loading} setLoading={setLoading}/>
                        </Route>
                        <Route path="/privacy">
                              <PrivacyPolicy homeLogo={appConfigData.home_logo} banners={banners} loading={loading}/>
                        </Route>
                        <Route path="/terms">
                              <TermsAndConditions homeLogo={appConfigData.home_logo} banners={banners} loading={loading}/>
                        </Route>
                        <Route path="/sorry">
                              <Sorry homeLogo={appConfigData.home_logo} banners={banners} loading={loading}  setLoading={setLoading}/>
                        </Route>
                           <ProtectedRoute path="/game/:title/:id"
                              component={(routeProps) => (
                              <Game
                              {...routeProps}
                              allGames={games}
                              view_all={appConfigData.view_btn_txt}
                              portrait_txt={appConfigData.portrait_txt}
                              rotate_txt={appConfigData.rotate_txt}
                              landscape_txt={appConfigData.landscape_txt}
                              similar_cat_txt={appConfigData.similar_cat_txt}/>
                            )}
                        />
                        <ProtectedRoute path="/profile"
                             component={(routeProps) =>
                               (<Profile 
                                    {...routeProps}
                                 status_txt={appConfigData.status_txt} validity_text={appConfigData.validity_text}
                                 plantype_text={appConfigData.plantype_text}/>)}
                        />
                         <ProtectedRoute path="/category"
                             component={(routeProps) =>
                               (<Category
                                    {...routeProps}
                                     play={appConfigData.play_text} />)}
                        />
                        <ProtectedRoute path="/language"
                        component={(routeProps) =>
                               ( <Language
                                    {...routeProps}
                                     langObj={appConfigData?.sidemenu?.language}
                              />)}
                        />
                        <ProtectedRoute path="/unsub"
                            component={(routeProps) =>
                              ( <Unsubscribe 
                                    {...routeProps}
                                unsub_mode={appConfigData?.unsub_mode}
                                unsubButtonText={appConfigData?.sidemenu?.unsub}
                                unsubText={appConfigData?.unsub_msg_txt}
                                status_txt={appConfigData?.status_txt}
                                validity_text={appConfigData.validity_text}
                                plantype_text={appConfigData.plantype_text}
                                />
                              )}
                        />
                        <Route path="*">
                              <NotFound />
                        </Route>
                        
                  </Switch>
            </section>
      );
}
export default App
